import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import ChecklistItem from './ChecklistItem';

const ChecklistPhase = ({ phase, index, done, filter, onToggle, onAdd, onRemove }) => {
  const [draft, setDraft] = useState('');
  const complete = phase.total > 0 && phase.doneCount === phase.total;
  const visible = phase.tasks.filter((t) =>
    filter === 'todo' ? !done[t.id] : filter === 'done' ? !!done[t.id] : true
  );

  if (filter !== 'all' && visible.length === 0) return null;

  const submit = (e) => {
    e.preventDefault();
    onAdd(phase.id, draft);
    setDraft('');
  };

  return (
    <section
      className="bg-white rounded-2xl border border-[#EFE6E9] shadow-sm overflow-hidden animate-fade-in-up"
      style={{ animationDelay: `${Math.min(index, 6) * 80}ms` }}
      data-testid={`checklist-phase-${phase.id}`}
    >
      <header className="flex items-start justify-between gap-4 px-6 md:px-8 pt-7 pb-5 border-b border-[#F3ECEF]">
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase mb-2" style={{ color: '#DE92A9' }}>
            Phase {index + 1}
          </p>
          <h2
            className="text-2xl md:text-3xl leading-tight tracking-tight"
            style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
          >
            {phase.title}
          </h2>
          <p className="text-sm mt-1.5 italic" style={{ color: '#757B7F' }}>{phase.subtitle}</p>
        </div>
        <span
          className={`shrink-0 text-xs tracking-[0.15em] font-semibold px-3.5 py-1.5 rounded-full ${
            complete ? 'text-white' : 'text-[#C9758F] bg-[#FBF3F5]'
          }`}
          style={complete ? { backgroundColor: '#DE92A9' } : undefined}
          data-testid={`checklist-phase-count-${phase.id}`}
        >
          {complete ? 'DONE' : `${phase.doneCount}/${phase.total}`}
        </span>
      </header>

      <div className="h-1 bg-[#F3ECEF]">
        <div
          className="h-full transition-all duration-500"
          style={{ width: `${phase.total ? (phase.doneCount / phase.total) * 100 : 0}%`, backgroundColor: '#DE92A9' }}
        />
      </div>

      <ul className="px-2 md:px-4 py-3 space-y-0.5">
        {visible.map((task) => (
          <ChecklistItem
            key={task.id}
            task={task}
            checked={!!done[task.id]}
            onToggle={() => onToggle(task.id)}
            onRemove={() => onRemove(phase.id, task.id)}
          />
        ))}
      </ul>

      <form onSubmit={submit} className="flex items-center gap-2 px-6 md:px-8 pb-6 pt-1">
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Add your own task to this phase"
          maxLength={120}
          className="flex-1 bg-[#FAF9F7] border border-[#EFE6E9] rounded-full px-4 py-2.5 text-sm text-[#2C2C2C] placeholder-[#C0B9B0] focus:outline-none focus:border-[#DE92A9] focus:ring-2 focus:ring-[#DE92A9]/20"
          data-testid={`checklist-custom-input-${phase.id}`}
        />
        <button
          type="submit"
          disabled={!draft.trim()}
          className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-white transition-all disabled:opacity-40 hover:scale-105"
          style={{ backgroundColor: '#DE92A9' }}
          aria-label="Add task"
          data-testid={`checklist-custom-add-${phase.id}`}
        >
          <Plus size={18} />
        </button>
      </form>
    </section>
  );
};

export default ChecklistPhase;
